// ─────────────────────────────────────────────────────────────────
// Glass-i — HR Employees API client (HRMS-1 + HRMS-2 sub-resources).
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/hrms/employees';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : resp && resp.data;
}
const enc = encodeURIComponent;

// Factory for the three 1:N sub-resources (documents/contacts/addresses).
function subResource(name) {
  return {
    list:   (empId)             => client.get(`${BASE}/${enc(empId)}/${name}`).then(unwrap),
    create: (empId, payload)    => client.post(`${BASE}/${enc(empId)}/${name}`, payload).then(unwrap),
    update: (empId, id, payload) => client.put(`${BASE}/${enc(empId)}/${name}/${enc(id)}`, payload).then(unwrap),
    remove: (empId, id)         => client.delete(`${BASE}/${enc(empId)}/${name}/${enc(id)}`).then(unwrap)
  };
}

export const hrEmployeesApi = {
  list:         (params = {}) => client.get(BASE, { params }).then(unwrap),
  salespersons: (params = {}) => client.get(`${BASE}/salespersons`, { params }).then(unwrap),
  get:          (id)          => client.get(`${BASE}/${enc(id)}`).then(unwrap),
  create:       (payload)     => client.post(BASE, payload).then(unwrap),
  update:       (id, payload) => client.put(`${BASE}/${enc(id)}`, payload).then(unwrap),
  remove:       (id)          => client.delete(`${BASE}/${enc(id)}`).then(unwrap),
  // HRMS-2 sub-resources
  documents:    subResource('documents'),
  contacts:     subResource('contacts'),
  addresses:    subResource('addresses'),
  salespersonHistory: (id)    => client.get(`${BASE}/${enc(id)}/salesperson-history`).then(unwrap),
  // ── HRMS-3 ──
  history:        (id, params = {}) => client.get(`${BASE}/${enc(id)}/history`, { params }).then(unwrap),
  reportingTree:  (id)          => client.get(`${BASE}/${enc(id)}/reporting-tree`).then(unwrap),
  // Provisioning foundation
  getProvisioning: (id)         => client.get(`${BASE}/${enc(id)}/provisioning`).then(unwrap),
  linkUser:        (id, userId) => client.put(`${BASE}/${enc(id)}/link-user`, { userId }).then(unwrap),
  provisionUser:   (id, payload) => client.post(`${BASE}/${enc(id)}/provision-user`, payload).then(unwrap),
  enableLogin:     (id)         => client.put(`${BASE}/${enc(id)}/enable-login`, {}).then(unwrap),
  disableLogin:    (id)         => client.put(`${BASE}/${enc(id)}/disable-login`, {}).then(unwrap),
  lockLogin:       (id, reason) => client.put(`${BASE}/${enc(id)}/lock-login`, { reason }).then(unwrap),
  unlockLogin:     (id, reason) => client.put(`${BASE}/${enc(id)}/unlock-login`, { reason }).then(unwrap)
};

export default hrEmployeesApi;
